import { useState } from "react";
import {
  PayPalButtons,
  PayPalScriptProvider
} from "@paypal/react-paypal-js";

import scraperApi from "api";
import { BillingInputName } from "v2/dataroutes/BillingData";

export default function PayPalComponents(
  {
    validate = true,
    inputName = BillingInputName.paymentSource + ".billing_agreement_token",
    onApproveBillingAgreement,
  }: {
    validate?: boolean,
    inputName?: string,
    onApproveBillingAgreement?: (token: string | undefined) => void,
  }
) {

  const [ billingAgreementToken, setBillingAgreementToken ] = useState<string | undefined>();

  return (
    <>
      { validate && ( /* little hack to make the form and the submit button respond to switching between the credit card and paypal tabs. SubmitButton's mutationobserver will kick in here */
        <input type="hidden" name={ inputName } value={ billingAgreementToken || "" } />
      ) }
      <PayPalScriptProvider
        options={ {
          clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID!,
          disableFunding: "card",
          vault: true,
          intent: "tokenize",
        } }
      >
        <PayPalButtons
          createBillingAgreement={ async () => {
            setBillingAgreementToken(undefined);
            const billingAgreementTokenResponse = await scraperApi.billing.payPal.createBillingAgreementToken();
            return billingAgreementTokenResponse.billingAgreementToken;
          } }
          onApprove={ async (data) => {
            const token = data.billingToken ?? undefined;
            setBillingAgreementToken(token);
            onApproveBillingAgreement?.(token);
          } }
        />
      </PayPalScriptProvider>
    </>
  );
}
